import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { toast } from "react-toastify";
import api from "service/api";
import VocabularyLibrarySelect from "components/VocabularyLibrarySelect";

function StepTranscription({ next, back }) {
  const { register, setValue, watch } = useFormContext();
  const [languages, setLanguages] = useState([]);
  const [providers] = useState([
    { name: "Voice AI", value: "VOICE-AI" },
    // { name: "Whisper Replicate", value: "WHISPER-REPLICATE" },
    // { name: "Link 2 Go", value: "LINK2GO" },
  ]);
  const provider = watch("provider");
  const languageObj = watch("language");
  const data_source_type = watch("data_source_type");

  useEffect(() => {
    if (data_source_type !== "AUDIO") {
      next();
    }
  }, [data_source_type, next]);

  useEffect(() => {
    api
      .get(`/languages`)
      .then((response) => {
        const langs = response.data.map((item) => ({
          label: `${item.code}-${item.region}`,
          value: item.id,
        }));
        setLanguages(langs);
        if (!provider) setValue("provider", providers[0].value);
        if ((!languageObj || !languageObj.id) && langs.length > 0) {
          const defaultLang =
            langs.find((lang) => lang.label === "pt-BR") || langs[0];
          setValue("language", {
            id: defaultLang.value,
            name: defaultLang.label,
          });
        }
      })
      .catch(() => toast.error("Erro ao recuperar as linguagens disponíveis!"));
  }, []);

  const handleLanguageChange = (e) => {
    const selected = languages.find((lang) => lang.value === e.target.value);
    setValue(
      "language",
      selected ? { id: selected.value, name: selected.label } : null,
    );
  };

  return (
    <div className="card bg-secondary shadow">
      <div className="card-header bg-white border-0">
        <div className="row align-items-center">
          <div className="col-8">
            <h3 className="mb-0">Configurações de transcrição</h3>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div>
          <div className="mb-3">
            <label className="form-control-label">Provedor</label>
            <select className="form-control" {...register("provider")}>
              {providers.map((provider) => (
                <option key={provider.name} value={provider.value}>
                  {provider.name}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-3">
            <label className="form-control-label">Idioma</label>
            <select
              className="form-control"
              value={languageObj?.id || ""}
              onChange={handleLanguageChange}
            >
              {languages.map((language) => (
                <option key={language.label} value={language.value}>
                  {language.label}
                </option>
              ))}
            </select>
          </div>
          <VocabularyLibrarySelect />
          <div className="d-flex justify-content-between">
            <button type="button" className="btn btn-secondary" onClick={back}>
              Voltar
            </button>
            <button
              type="button"
              className="btn btn-success"
              onClick={next}
              disabled={!languageObj?.id}
            >
              Próximo
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StepTranscription;
